import { styled } from '@mui/material/styles';

export const StyledTotalRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  '&:not(:last-child)': {
    marginBottom: '12px',
  },
});
